/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

import Loading from 'components/Loading/Loading';

import ActionDrawerHeader from 'views/ActionDrawer/components/ActionDrawerHeader/ActionDrawerHeader';

import Form from 'forms/_.extend';

import EnableAccountForm from './EnableAccountForm/EnableAccountForm';
import EnableAccountSuccess from './EnableAccountSuccess/EnableAccountSuccess';
import EnableAccountError from './EnableAccountError/EnableAccountError';

import styles from '../../../ActionDrawer.module.scss';

type TypeProps = {|
  currentAccountDetails: Object,
  actionDrawerStore: TypeActionDrawerStore,
  accountStore: Object,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore', 'accountStore')
@observer
export default class EnableAccount extends React.Component<*> {
  createForm = () => {
    const { t }: TranslatorProps = this.props;
    const { actionDrawerStore, accountStore }: TypeProps = this.props;
    const currentAccountDetails: Object = this.props.currentAccountDetails;
    const fields: Array<Object> = [
      {
        name: 'enableAccountForm',
        label: t('general:actions.enable_trading_account'),
        title: 'Enable Account',
        fields: [
          {
            name: 'reason',
            label: t('general:reasons.provide_reason'),
            rules: 'required',
            value: '',
          },
        ],
      },
    ];

    const hooks: Object = {
      onInit(data: Object) {
        if (!accountStore.details) {
          accountStore.loadDetails(currentAccountDetails.id);
        }
      },
      onSuccess(data: Object) {
        const { reason }: Object = data.values().enableAccountForm;

        actionDrawerStore.enableDisableAccount(currentAccountDetails.id, {
          is_enabled: true,
          activity_reason: reason,
        });
      },
    };

    return new Form(
      { fields },
      {
        hooks,
        options: {
          validateOnInit: true,
          validateOnChange: true,
        },
        name: 'Enable Account',
      }
    );
  };

  render(): React.Element<*> {
    const { t }: TranslatorProps = this.props;
    const { currentAccountDetails, actionDrawerStore }: TypeProps = this.props;

    if (actionDrawerStore.loading) {
      return <Loading />;
    }

    if (actionDrawerStore.error) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.error}`}>
          <ActionDrawerHeader title={t('general:actions.enable_trading_account')} />
          <EnableAccountError currentAccountDetails={currentAccountDetails} />
        </div>
      );
    }

    if (actionDrawerStore.success) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.enabled}`}>
          <ActionDrawerHeader title={t('general:actions.enable_trading_account')} />
          <EnableAccountSuccess currentAccountDetails={currentAccountDetails} />
        </div>
      );
    }

    return (
      <div className={styles['action-drawer-form']}>
        <ActionDrawerHeader title={t('general:actions.enable_trading_account')} />
        <EnableAccountForm currentAccountDetails={currentAccountDetails} form={this.createForm()} />
      </div>
    );
  }
}
